export default function TicketManagementIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_6673_12008)">
        <path
          d="M13.8297 17.2494L11.7923 17.7888C9.90658 18.2881 8.96366 18.5377 8.22488 18.1288C7.48611 17.72 7.23996 16.8123 6.74765 14.997L5.52926 10.5043C5.03696 8.68899 4.79081 7.78137 5.22371 7.06232C5.65661 6.34328 6.59951 6.09366 8.48533 5.59441L11.8189 4.71186C13.7047 4.21261 14.6476 3.96298 15.3864 4.37182C16.1252 4.78067 16.3713 5.68833 16.8636 7.50364L18.0868 12.0142C18.2962 12.7862 18.4009 13.1722 18.2858 13.5351M13.8297 17.2494C14.4564 17.0835 14.4614 17.0808 14.9488 16.6627L17.2353 14.7007C17.859 14.1656 18.1708 13.898 18.2858 13.5351M13.8297 17.2494C13.8297 17.2494 14.3197 13.4218 15.4167 12.917C16.661 12.3443 18.2858 13.5351 18.2858 13.5351"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
        <path
          d="M14.168 4.16798C14.1143 3.27349 13.9657 2.71041 13.5416 2.30668C12.8921 1.68827 11.8496 1.6852 9.76463 1.67903L6.07898 1.66814C3.99404 1.66198 2.95158 1.6589 2.30576 2.27347C1.65994 2.88805 1.66298 3.88026 1.66907 5.8647L1.68412 10.7759C1.6902 12.7604 1.69324 13.7526 2.34283 14.371C2.99243 14.9894 4.03489 14.9925 6.11983 14.9987L6.68718 15.0003"
          stroke="currentColor"
          strokeWidth="1.5"
        />
      </g>
      <defs>
        <clipPath id="clip0_6673_12008">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0 0.000488281)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
